import { PP2Locale } from '@tq/ui-components/dist/pp2/utils';

export const getTheme = (locale: string): PP2Locale => {
  switch (locale) {
    default:
    case 'default':
      return 'default';
    case 'england':
    case 'wales':
    case 'northern-ireland':
    case 'tq':
      return locale;
  }
};
